import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
	to {
		transform: rotate(360deg);
	}
`

const Wrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: ${props => (props.$block ? '28px 0' : '10px 0')};
	justify-content: ${props => (props.$block ? 'center' : 'flex-start')};
	color: ${props => props.theme.mutedColor};
	font-size: 16px;
`

const Circle = styled.span`
	flex: 0 0 auto;
	width: ${props => props.$size}px;
	height: ${props => props.$size}px;
	border-radius: 50%;
	border: 3px solid ${props => props.theme.lineColor};
	border-top-color: ${props => props.theme.primaryColor};
	animation: ${spin} 0.8s linear infinite;
	@media (prefers-reduced-motion: reduce) {
		animation-duration: 2s;
	}
`

const Spinner = ({ text, size = 22, block = false }) => (
	<Wrapper role="status" aria-live="polite" $block={block}>
		<Circle $size={size} aria-hidden="true" />
		{text && <span>{text}</span>}
	</Wrapper>
)

export default Spinner
